<template>
  <div>
    <f-data-table id="orphaned-users"
                  heading="Orphaned Users"
                  :data-uri="data_uri"
                  :columns="columns"
                  :locked="true"
                  :selectable-rows="true"
                  icon="la la-users"
                  :server-side="true">
      <template #_actions="props">
        <button type="button"
                class="btn btn-ss btn-icon-sm"
                :disabled="loading"
                @click="props.reloadData()">
          <i class="flaticon2-refresh" />Reload Data
        </button>
      </template>
      <template #_row_controls="props">
        <button class="btn btn-ss"
                type="button"
                :disabled="loading"
                @click="props.do({ cb: deleteUsers })">
          Delete
        </button>
        <button class="btn btn-ss"
                type="button"
                :disabled="loading"
                @click="props.do({ cb: assignUsersToCustomer })">
          Assign to Customer
        </button>
      </template>
    </f-data-table>
    <delete-confirm-modal name="delete-confirm"
                          :entities-to-delete="selected_users"
                          entity-type="user"
                          :callback="modalCallback" />
    <assign-users-to-customer-modal :users="selected_users"
                                    :callback="modalCallback" />
  </div>
</template>
<script>
import FDataTable from "VuePartials/App/Storage/FDataTable/FDataTable.vue";
import DeleteConfirmModal from 'VueModals/DeleteConfirmModal';
import AssignUsersToCustomerModal from "VueModals/AssignUsersToCustomerModal.vue";
import axios from "axios";
import toastr from "toastr";

export default {
  components: {
    FDataTable,
    AssignUsersToCustomerModal,
    DeleteConfirmModal,
  },
  data() {
    return {
      data_uri: `/api/v1/admin/user/orphaned`,
      loading: false,
      modalCallback: null,
      selected_users: [],
      customers: window.customers,
      columns: [
        {
          field: `name`,
          display: `Name`,
        },
        {
          field: `email`,
          display: `Email`,
        },
      ],
    };
  },
  mounted() {
    EventBus.$on(`fdt-rows-selected`, (ev) => {
      this.selected_users = ev;
    });
  },
  methods: {
    async deleteUsers(...users) {
      // Are you sure modal
      // foreach users as user
      // axios.delete /api/v1/user/{user_id}

      this.loading = true;
      this.modalCallback = async () => {
        try {
          await Promise.all(users.map(user => axios.delete(`/api/v1/user/${user.uuid}`)));
          toastr.success(`Successfully deleted ${users.length} users.`);
        } catch (err) {
          this.handleAxiosError(err);
        } finally {
          this.loading = false;
        }
      };

      const modal_res = await this.fireModal('delete-confirm');

      if (!modal_res.data.confirm) {
        this.loading = false;
        return false;
      } else {
        return true;
      }
    },
    async assignUsersToCustomer(...users) {
      // foreach user as user
      // assign to given customer id
      // axios.post /api/v1/user/{id}/updateCustomers ?customer_uuids={the_selected_uuid}
      this.loading = true;
      this.modalCallback = async (data) => {
        try {
          await Promise.all(users.map(user => axios.post(`/api/v1/user/${user.uuid}/update-customers`, {
            customer_uuids: [data.customer.uuid],
          })));
          toastr.success(`Successfully assigned ${users.length} users to customer '${data.customer.name}'`);
        } catch (err) {
          window.handleAxiosError(err);
        } finally {
          this.loading = false;
        }
      };

      const modal_res = await this.fireModal(`assign-users-to-customer`);

      if (!modal_res.data.confirm) {
        this.loading = false;
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>
